import { useTranslation } from 'react-i18next';
/**
 * A PÉNZFORGALMI JELÖLÉS (#55) — tömör `--official` címke, mert NAV-ból jött,
 * hivatalos adat. ⚠️ NEM VILLOG (WCAG 2.2.2, `akadalymentesites.md`): állandó,
 * és a felirata szöveg, tehát a képernyőolvasó a számlaszámmal együtt
 * felolvassa. A `title` az egérhasználónak mondja meg, honnan tudjuk.
 *
 * KÉT HELYEN ÁLL, és ezért közös: a hiánylista sorában és a munkalista
 * jelöltjeinél (Viktor, 2026-09-29). Mindkét helyen a SZÁMLASZÁM MÖGÖTT, és
 * elé a hívó VALÓDI SZÓKÖZT tesz — margóval a képernyőolvasó a kettőt egy
 * szónak olvashatná.
 */
export function CashAccountingMark() {
  const { t } = useTranslation();
  return (
    <span className="cash-mark" title={t('discrepancyList.cashAccountingHint')}>
      <svg viewBox="0 0 12 12" aria-hidden="true" focusable="false">
        <circle cx="6" cy="6" r="4.6" fill="none" stroke="currentColor" strokeWidth="1.4" />
        <path
          d="M6 3.4v5.2M4.4 4.8h2.3a1 1 0 0 1 0 2H5.3a1 1 0 0 0 0 2h2.3"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.1"
        />
      </svg>
      {t('discrepancyList.cashAccounting')}
    </span>
  );
}
